import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M8.83063 6.91304C8.83063 5.13595 10.2166 3.75 11.9937 3.75C13.7708 3.75 15.1567 5.13595 15.1567 6.91304C15.1567 7.32726 15.4925 7.66304 15.9067 7.66304C16.3209 7.66304 16.6567 7.32726 16.6567 6.91304C16.6567 4.30753 14.5992 2.25 11.9937 2.25C9.38816 2.25 7.33063 4.30753 7.33063 6.91304V9.29346H6.9502C5.43141 9.29346 4.2002 10.5247 4.2002 12.0435V19C4.2002 20.5188 5.43141 21.75 6.9502 21.75H17.0372C18.5559 21.75 19.7872 20.5188 19.7872 19V12.0435C19.7872 10.5247 18.5559 9.29346 17.0372 9.29346H8.83063V6.91304ZM5.7002 12.0435C5.7002 11.3531 6.25984 10.7935 6.9502 10.7935H17.0372C17.7275 10.7935 18.2872 11.3531 18.2872 12.0435V19C18.2872 19.6903 17.7275 20.25 17.0372 20.25H6.9502C6.25984 20.25 5.7002 19.6903 5.7002 19V12.0435ZM11.1785 15.5217C11.1785 15.9719 11.5434 16.3369 11.9937 16.3369C12.4439 16.3369 12.8089 15.9719 12.8089 15.5217C12.8089 15.0715 12.4439 14.7065 11.9937 14.7065C11.5434 14.7065 11.1785 15.0715 11.1785 15.5217ZM11.9937 17.8369C10.715 17.8369 9.67846 16.8004 9.67846 15.5217C9.67846 14.243 10.715 13.2065 11.9937 13.2065C13.0099 13.2065 13.8733 13.8613 14.1848 14.772H15.1241C15.5383 14.772 15.8741 15.1078 15.8741 15.522C15.8741 15.9362 15.5383 16.272 15.1241 16.272H14.1846C13.8729 17.1824 13.0097 17.8369 11.9937 17.8369Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const UnlockOutlined = React.forwardRef(IconComponent);
UnlockOutlined.displayName = 'UnlockOutlined';

export { UnlockOutlined };
